import { Product } from '@/services/api/contracts/catalog/types';
import { useCatalogueService } from '@/services/catalogue/useCatalogueService';
import { useIsProductSelected } from '@/services/catalogue/useCustomerCatalogueService';
import { usePOIsProductSelected } from '@/services/purchaseOrders/usePurchaseOrderService';
import { FunctionComponent } from 'react';
import { BundleSelectedProductIndicator } from '../BundleSelectedProductIndicator';
import { POSelectedProductIndicator } from '../POSelectedProductIndicator';

interface ProductCardCustomerContentProps {
  product: Product;
}

const ProductCardCustomerContent: FunctionComponent<ProductCardCustomerContentProps> = ({ product }) => {
  const isPurchaseOrder = useCatalogueService(state => state.inPurchaseOrder);

  const isProductInABundle = useIsProductSelected(product);
  const isProductInPO = usePOIsProductSelected(product);

  return (
    <>
      {!isPurchaseOrder && isProductInABundle && <BundleSelectedProductIndicator productId={product.id} />}
      {isPurchaseOrder && isProductInPO && <POSelectedProductIndicator product={product} />}
    </>
  );
};

export default ProductCardCustomerContent;
